import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Drawer, List, ListItem, ListItemIcon, Typography, withStyles, Grid, IconButton } from "@material-ui/core";
import EBSettings from '../EmploymentBillboard/Admin/App';
import GlobalSettings from '../EmploymentBillboard/Admin/GlobalConfigurations'
import Archive from '../EmploymentBillboard/Admin/Archive';
import { faTh } from '@fortawesome/pro-solid-svg-icons';
import { faTimes, faBars, faArchive } from '@fortawesome/pro-light-svg-icons';
import { faBallotCheck, faSlidersH } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Provider } from 'react-redux';
import { adminStore as store } from '../EmploymentBillboard/store';
import ReduxToastr from 'react-redux-toastr';
import LogoutWarning from '../common/components/LogoutWarning';
import { getApp, productList, getProduct } from '../services/productList';
import { UserProfileMenu, NotMobileSupported } from '../common-client2/src/components';
import axios from 'axios';
import { isMobile } from 'react-device-detect';


const adminApp = getApp('adminSettings');

const styles = () => ({
    root: {
        display: 'flex',
        height: '100vh',
    },
    fullHeight: {
        height: '100%'
    },
    textAlignCentered: {
        textAlign: 'center'
    },
    settingContainer: {
        width: '99%',
        paddingLeft: 20
    },
    drawerPaper: {
        width: '16%',
        backgroundColor: '#0a54a2',
        minWidth: 240
    },
    drawer: {
        flexShrink: 0,
        width: '16%',
        minWidth: 240
    },
    drawerPaperV2: {
        width: 240,
        backgroundColor: '#FFFFFF',
        minWidth: '170px'
    },
    drawerV2: {
        flexShrink: 0,
        zIndex: 2,
    },
    drawerWrapperV2: {
        height: '100%',
    },
    navElement: {
        fontWeight: 700,
    },
    listItem: {
        padding: '16px'
    },
    icon: {
        fontSize: '20px'
    },
    content: {
        flex: 1,
        padding: '10px 15px',
    },
    logoDrawer: {
        backgroundColor: '#6EA0D7',
        textAlign: 'center',
        padding: '20px',
        margin: '20px',
        border: '1px solid #6ea0d7',
        borderRadius: '3px',
        minHeight: '1px'
    },
    logoImg: {
        width: '80%'
    },
    selected: {
        color: '#0A54A2 !important',
        backgroundColor: 'rgba(0, 0, 0, 0) !important'
    },

    backdrop: {
        width: '100vw',
        height: '100vh',
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1
    },
    contentWrapper: {
        position: 'relative'
    },
    topButtons: {
        display: 'flex',
        justifyContent: "space-between",
    }
});

const appIcon = {
    callList: ['fal', 'phone'],
    quotaManagement: ['fal', 'chart-pie'],
    requestCalendar: ['fal', 'calendar'],
    hcScheduleReport: ['fal', 'clock'],
    dailyShiftBidding: faBallotCheck,
    workplanManager: faTh,
    employmentBillboard: faTh,
    globalConfigurations: faSlidersH,
    archive: faArchive,
}

class AdminSettings extends Component {
    constructor(props) {
        super(props);

        const jwtUserInfo = JSON.parse(sessionStorage.getItem('jwtUserInfo'));
        const initiales = sessionStorage.getItem('userInitials');
        const firstName = jwtUserInfo?.FirstName ? jwtUserInfo?.FirstName : "";
        const lastName = jwtUserInfo?.LastName ? jwtUserInfo?.LastName : "";

        this.state = {
            applicationSelected: localStorage.getItem('appSelected') || getProduct("employmentBillboard").name,
            extended: false,
            buildInfos: {
                version: "-",
                environment: "-"
            },
            userInfos: {
                firstName: firstName,
                lastName: lastName,
                initials: initiales,
            }
        };

        this.apps = productList?.filter((p) => p?.env.includes("admin") && p?.api === adminApp.api);

        const options = {
            headers: {
                Authorization: sessionStorage.getItem('authToken') ?? '',
            }
        };
        axios.get(process.env.REACT_APP_API_DOTNET + '/api/v1/common/buildInfos', options).then(async buildInfos => {
            this.setState({ buildInfos: { ...buildInfos.data } })
        });
    }

    handleOnClickApplication = (name) => {
        this.setState({ applicationSelected: name, extended: false });
        localStorage.setItem('adminAppSelected', name);
    }

    handleSideMenu = (event, extend) => {
        event.stopPropagation()
        this.setState({ extended: extend })
    }

    renderDrawerV2(classes, applicationSelected) {
        return (
            <Drawer
                className={classes.drawerV2}
                variant="persistent"
                classes={{ paper: classes.drawerPaperV2 }}
                anchor="left"
                open={this.state.extended}
            >
                <Grid
                    container
                    direction={'column'}
                    justifyContent="space-between"
                    className={classes.drawerWrapperV2}
                >
                    <Grid container item>
                        <Grid item xs={10}></Grid>
                        <Grid item xs={2}>
                            <IconButton onClick={(event) => this.handleSideMenu(event, false)}>
                                <FontAwesomeIcon icon={faTimes} />
                            </IconButton>
                        </Grid>
                        <Grid item xs={12}>
                            <List>
                                {this.apps.map((app, index) => {
                                    return (
                                        <ListItem button key={index} value={app.name} className={classes.listItem} classes={{ selected: classes.selected }}
                                            onClick={() => { this.handleOnClickApplication(app.name) }} selected={app.name === applicationSelected}>
                                            <ListItemIcon className={classes.icon}>
                                                <FontAwesomeIcon icon={appIcon[app.name]} className={classes.navElement} />
                                            </ListItemIcon>
                                            <Typography className={classes.navElement}>{this.props.t(`${app.name}:navBar.appName`)}</Typography>
                                        </ListItem>)
                                })}
                            </List>
                        </Grid>
                    </Grid>
                </Grid>
            </Drawer>
        );
    }

    render() {
        if(isMobile){
            return (
                <NotMobileSupported/>
            )
        }

        const { classes, t } = this.props;
        const { applicationSelected, extended, userInfos, buildInfos } = this.state;
        const appComponent = {
            employmentBillboard: <EBSettings />,
            archive: <Archive />,
            globalConfigurations: <GlobalSettings />,
        }

        const app = appComponent[applicationSelected];

        return (
            <Provider store={store}>
                <div className={classes.root}>
                    <div className={classes.content}>
                        <div className={classes.topButtons}>
                            <IconButton onClick={(event) => this.handleSideMenu(event, true)}>
                                <FontAwesomeIcon icon={faBars} />
                            </IconButton>
                            <UserProfileMenu
                                fullName={`${userInfos.firstName} ${userInfos.lastName}`}
                                initials={userInfos.initials}
                                version={buildInfos.version}
                                environement={t(`environment.${buildInfos.environment}`, { ns: 'common' })}
                                labels={{
                                    sectionTitleAbout: t(`userMenu.about`, { ns: 'common' }),
                                    aboutVersion: t(`userMenu.version`, { ns: 'common' }),
                                    aboutEnvironment: t(`userMenu.environment`, { ns: 'common' })
                                }}
                            />
                        </div>
                        {extended ? <div className={classes.backdrop} onClick={(event) => this.handleSideMenu(event, false)}></div> : null}
                        {this.renderDrawerV2(classes, applicationSelected)}
                        <div className={classes.contentWrapper}>
                            {app}
                        </div>
                    </div>
                </div>
                <ReduxToastr
                    timeOut={4000}
                    newestOnTop={false}
                    preventDuplicates
                    position="top-center"
                    transitionIn="fadeIn"
                    transitionOut="fadeOut"
                    closeOnToastrClick
                />
                <LogoutWarning />
            </Provider>
        )
    }
}

export default withTranslation(['common', 'hcScheduleReport', 'workplanManager', 'quotaManagement', 'requestCalendar', 'dailyShiftBidding'])(withStyles(styles)(AdminSettings));